/** @format */

import React, { useState, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { InputTextarea } from "primereact/inputtextarea";
import ThreeDotsLoader from "../common/ThreeDotsLoader";
import useSaveOutsideMarkets from "./hooks/useSaveOutsideMarkets";
import { Messages } from "primereact/messages";
import { isOutSideMarketEmpty } from "./utils/utils";
import { REGIONS } from "./constants/constants";
// import service from "../../utils/service"
import { BUSINESS_UNIT } from "../../utils/PreviousSession.constants";

function OutsideMarkets(props) {
  const [editContent, setEditContent] = useState(false);
  const [isSectionInValid, setIsSectionInValid] = useState(false);
  const [temp, setTemp] = useState("");
  const loading = props.loading;
  const msgRef = useRef();
  const mutation = useSaveOutsideMarkets();
  const headerImgSrc =
    props.businessUnit !== BUSINESS_UNIT.COCOA
      ? "https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/OutsideMarketHeader.png"
      : "https://miappstorage.dev.cglcloud.in/api/miappstorage/v1/downloadImage/cocoa_outside_markets.png";

  // React.useEffect(() => {
  //   service.getImageCode("OutsideMarketHeader.jpeg", setHeaderImgSrc)
  // }, []);

  function handleEdit(section) {
    setTemp(section.content);
    setEditContent(true);
    props.setEditing("outsideMarkets", true, false);
  }

  function handleCancel() {
    setEditContent(false);
  }

  function handleSave(section) {
    section.content = temp;
    setEditContent(false);

    props.getSectionData(section);
  }

  let section = props.section;
  function renderEditContent(publish, diff_date) {
    let returnObj =
      publish === true || diff_date < 0 ? null : (
        // <div
        //   style={{
        //     fontSize: "16px",
        //     color: "grey",
        //     margin: "8px",
        //   }}
        //   onClick={() => {
        //     handleEdit(section);
        //   }}
        // >
        //     Edit Content
        // </div>
        <tr className='editContent'>
          <td>
            <span
              style={{ fontSize: "16px", color: "grey" }}
              onClick={() => {
                handleEdit(section);
              }}
            >
              Edit Content
            </span>
          </td>
        </tr>
      );
    return returnObj;
  }

  function renderContent(editContent) {
    let returnObj = (
      <div>
        <div
          style={{
            fontSize: "14px",
            // color: "#cccccc",
            margin: "8px",
            whiteSpace: "pre-line",
            textAlign: "justify",
            wordBreak: "break-word",
          }}
        >
          {section && section.content}
        </div>
      </div>
    );
    return returnObj;
  }

  function handleSectionSave() {
    if (isOutSideMarketEmpty(section)) {
      setIsSectionInValid(true);
    } else {
      mutation.mutate(
        {
          ...section,
          reportDate: props.reportDate,
          regionId: props.regionId,
          productLineId: props.productLineId,
        },
        {
          onSuccess: (data) => {
            if (msgRef.current) {
              msgRef.current.clear();
              msgRef.current.show([
                {
                  sticky: false,
                  severity: "success",
                  summary: "Success",
                  detail: "Outside Markets saved successfully",
                  closable: false,
                  life: 2000,
                },
              ]);
            }
            props.setEditing("outsideMarkets", false, false);
            props.updateSectionId("outsideMarkets", data.data);
            mutation.reset();
          },
          onError: () => {
            if (msgRef.current) {
              msgRef.current.clear();
              msgRef.current.show([
                {
                  sticky: true,
                  severity: "error",
                  summary: "Error",
                  detail: "Error saving Outside Markets",
                  closable: true,
                },
              ]);
            }
            props.setEditing("outsideMarkets", true, false);
            mutation.reset();
          },
        }
      );
    }
  }
  return (
    <div className='relative syndication__section__wrapper'>
      <table
        align='center'
        style={{
          width: "800px",
          textAlign: "justify",
          borderSpacing: "5px",
          borderCollapse: "separate",
          tableLayout: "'fixed'",
          fontFamily: "Helvetica, Arial, sans-serif",
        }}
      >
        <tbody>
          <tr>
            <td>
              <img
                src={props?.section?.headerImagePath || headerImgSrc}
                alt='Outisde market header'
                width='800'
                height='50'
                style={{
                  marginLeft: "auto",
                  marginRight: "auto",
                  display: "block",
                }}
              />
            </td>
          </tr>
        </tbody>
      </table>
      {(loading || mutation.isLoading) && (
        <div className='wtg__loader absolute'>
          <ThreeDotsLoader className='absolute' />
        </div>
      )}
      <table width='800' align='center' className='msg__container'>
        <Messages
          className='msg__content'
          ref={msgRef}
          onRemove={() => {
            console.log("REMOVED");
          }}
        />
      </table>
      <table
        align='center'
        style={{
          width: "800px",
          textAlign: "justify",
          borderSpacing: "5px",
          borderCollapse: "separate",
          tableLayout: "'fixed'",
          fontFamily: "Helvetica, Arial, sans-serif",
          marginBottom: "10px",
        }}
      >
        <tbody>
          <tr>
            <td valign='top'>
              {renderEditContent(props.publish, props.diff_date)}
              {renderContent(editContent)}
              {props.publish === true || props.diff_date < 0 ? null : (
                <Button
                  pt={{ label: { className: "mx-0" } }}
                  className='p-button p-button-sm diag-save-button savesectionbtn'
                  label='Save Section Content'
                  onClick={() => handleSectionSave()}
                />
              )}
            </td>
          </tr>
        </tbody>
      </table>
      <Dialog
        baseZIndex={10001}
        className='diag1'
        visible={editContent}
        style={{ width: "1000px" }}
        onHide={() => handleCancel()}
        focusOnShow={false}
      >
        <div className='diag-box'>
          <div className='grid'>
            <div className='col-12 p-0 diag-syndication'>Outside Markets</div>
            <div className='col-12 pl-0'>
              <InputTextarea
                required
                rows={20}
                value={temp}
                className='widthFull'
                onChange={(event) => setTemp(event.target.value)}
              />
            </div>
            <div className='col-12 flex flex-row-reverse'>
              <Button
                label='Cancel'
                className='p-button ml-2 p-button-sm diag-discard-button'
                onClick={() => handleCancel()}
              />
              <Button
                label='Save'
                onClick={() => handleSave(section)}
                className='p-button ml-2 p-button-sm diag-save-button'
              />
              {(props.businessUnit === BUSINESS_UNIT.COCOA &&
                (props.region === REGIONS.SA_PG || props.region === REGIONS.SA_ES)) ||
                props.regions.map((reg) => {
                  if (reg.value !== props.region) {
                    return (
                      <Button
                        key={reg.value}
                        label={"Copy from " + reg.value}
                        onClick={() => {
                          setEditContent(false);
                          props.getContentBasedonDateAndRegion(
                            reg.value,
                            "Outside Markets",
                            "current",
                            section,
                            props.getSectionData
                          );
                        }}
                        className='p-button ml-2 p-button-sm diag-save-button'
                      ></Button>
                    );
                  }
                  return <React.Fragment key={reg.value}></React.Fragment>;
                })}
              {/* { props.region!==REGIONS.NA &&
               <Button
                  label="Copy from NA"
                  onClick={() => {
                    setEditContent(false);
                    props.getContentBasedonDateAndRegion(REGIONS.NA, 'Previous Session','current', section, props.getSectionData)
                  }}
                  className="p-button ml-2 p-button-sm diag-save-button"
                />
              }
              { props.region!==REGIONS.EMEA &&
               <Button
                  label="Copy from EMEA"
                  onClick={() => {
                    setEditContent(false);
                    props.getContentBasedonDateAndRegion(REGIONS.EMEA, 'Previous Session','current', section, props.getSectionData)
                  }}
                  className="p-button ml-2 p-button-sm diag-save-button"
                />
              }
              { props.region!==REGIONS.SA &&
               <Button
                  label="Copy from SA"
                  onClick={() => {
                    setEditContent(false);
                    props.getContentBasedonDateAndRegion(REGIONS.SA, 'Previous Session','current', section, props.getSectionData)
                  }}
                  className="p-button ml-2 p-button-sm diag-save-button"
                />
              } */}
              <Button
                label='Copy from Yesterday'
                onClick={() => {
                  setEditContent(false);
                  props.getContentBasedonDateAndRegion(
                    props.region,
                    "Outside Markets",
                    "previous",
                    section,
                    props.getSectionData
                  );
                }}
                className='p-button ml-2 p-button-sm diag-save-button'
              />
            </div>
          </div>
        </div>
      </Dialog>
      <Dialog
        header='Outside Markets Validation'
        className='section__validation__dialog'
        baseZIndex={10001}
        visible={isSectionInValid}
        modal
        style={{ width: "350px" }}
        footer={
          <Button
            label='Okay'
            icon='pi pi-check'
            onClick={() => setIsSectionInValid(false)}
            className='p-button-text'
          />
        }
        onHide={() => setIsSectionInValid(false)}
      >
        <div className='flex flex-column' style={{ color: "#FFF" }}>
          <div className='flex align-items-center'>
            <i className='pi pi-exclamation-triangle mr-3' style={{ fontSize: "2rem" }} />
            <span>Please fill the section content</span>
          </div>
        </div>
      </Dialog>
    </div>
  );
}

export default OutsideMarkets;
